import _ from 'lodash';
import React, {useState} from 'react';

import {Button} from '../../../../../Button';
import {Icon} from '../../../../../Icon';
import {TraceObjSchemaForBaseObjectClass} from '../wfReactInterface/objectClassQuery';
import {PanelView} from './PanelView';

type PanelSwitchComparisonViewProps = {
  views: Array<TraceObjSchemaForBaseObjectClass<'ComparisonView'>>;
  currentViewId: string | null;
  currentViewerId: string | null;
  onLoadView: (
    view: TraceObjSchemaForBaseObjectClass<'ComparisonView'>
  ) => void;
};

export const PanelSwitchComparisonView = ({
  views,
  currentViewId,
  currentViewerId,
  onLoadView,
}: PanelSwitchComparisonViewProps) => {
  const [isShowingInfo, setIsShowingInfo] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const onInfoClick = () => setIsShowingInfo(!isShowingInfo);

  const filteredViews = views.filter(
    view =>
      view.val.label?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false
  );
  const sortedViews = _.orderBy(filteredViews, 'created_at', 'desc');

  return (
    <div className="w-[400px]">
      <div className="relative">
        <Icon
          name="search"
          className="absolute left-16 top-[10px] text-moon-400"
          size="sm"
        />
        <input
          type="text"
          placeholder="Search comparisons..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="w-full border-b border-moon-200 pb-12 pl-[44px] pr-16 pt-8 focus:outline-none dark:border-moon-700 dark:bg-moon-900"
        />
      </div>
      <div className="flex items-center rounded-[4px] px-16 py-8">
        <div className="font-semibold">Saved comparisons</div>
        <div className="ml-8 bg-oblivion/[0.05] px-6 dark:bg-moonbeam/[0.05]">
          {views.length}
        </div>
        <div className="flex-auto"></div>
        <div className="night-aware">
          <Button
            variant="ghost"
            size="small"
            icon="info"
            onClick={onInfoClick}
            tooltip="Toggle help information"
          />
        </div>
      </div>
      {isShowingInfo && (
        <div className="rounded-8 mx-16 mb-8 bg-moon-100 px-12 py-8 text-sm text-moon-500 dark:bg-moon-800">
          Save your comparison configurations including selected evaluations,
          metrics, and comparison dimensions for quick access.
        </div>
      )}
      <div className="max-h-[calc(100vh-24rem)] overflow-auto">
        {sortedViews.map(view => (
          <PanelView
            key={view.object_id}
            view={view}
            onLoadView={v =>
              onLoadView(
                v as TraceObjSchemaForBaseObjectClass<'ComparisonView'>
              )
            }
            isChecked={view.object_id === currentViewId}
            currentViewerId={currentViewerId}
          />
        ))}
      </div>
    </div>
  );
};
